module.exports = __webpack_public_path__ + "44b9a30d3ee687eeda58e763b352a831.png";